export default __webpack_public_path__ + "static/media/oh.e304643a.wav";